import React from 'react' // eslint-disable-line no-unused-vars
import CountryAwareComponent from './CountryAwareComponent'
import { languages } from './adminPanel/ManageTranslationField'

class PiSearchResult extends CountryAwareComponent {
  constructor (props) {
    super(props)

    this.componentName = 'PiSearchResult'
    this.state = {
      searchUserType: this.props.searchUserType
    }
  }

  componentWillReceiveProps ({ searchUserType }) {
    this.setState({ searchUserType })
  }

  render () {
    const languageContent = this.props.lang
    const piSearchLinks = this.props.piSearchLinks

    const linkArray = piSearchLinks ? piSearchLinks.split(',') : []

    let listItems = linkArray.map(link => (
      <li className='list-group-item' key={link.trim()}>
        <a href={link.trim()} data-tag='track-download' data-analytics-text={link.trim().split('/').pop()} className='anchor-link' target='_blank' rel='noopener noreferrer'>{link.trim().split('/').pop()}
        </a>
      </li>))

    if (piSearchLinks === null || piSearchLinks === '') {
      if (this.props.language === 'de' && this.state.searchUserType === 'ABBVIE_EMPLOYEE') {
        /* eslint-disable spellcheck/spell-checker */
        languageContent.piSearchResult = 'Verschreibende Informationen/Gebrauchsanweisungen'
        languageContent.emptyPiSearchResult = 'Die Fachinformation können Sie auf www.fachinfo.de herunterladen. ' +
          'Darüber hinaus enthält jede Antwort, die Sie von uns bekommen, ' +
          'jeweils die aktuelle Fachinformation und Packungsbeilage.'
        /* eslint-enable spellcheck/spell-checker */
      }
      listItems = <li className='list-group-item'> {languageContent.emptyPiSearchResult} </li>
    }

    const jsx = (
      <div>
        <h4 className='header-primary'>{languageContent.piSearchResult}</h4>
        <ul className='list-group'>
          {listItems}
        </ul>
      </div>

    )

    return this.countriesMatched() ? jsx : null
  }
}

export default PiSearchResult



// WEBPACK FOOTER //
// ./src/mi-app/PiSearchResult.js